import React from 'react';

const BrandList = [
    {
        image: './images/brand/brand-01.png'
    },
    {
        image: './images/brand/brand-02.png'
    },
    {
        image: './images/brand/brand-03.png'
    },
    {
        image: './images/brand/brand-04.png'
    },
    {
        image: './images/brand/brand-05.png'
    },
    {
        image: './images/brand/brand-06.png'
    },
    {
        image: './images/brand/brand-07.png'
    },
    {
        image: './images/brand/brand-08.png'
    },
    {
        image: './images/brand/brand-01.png'
    },
  
]

const BrandThree = ({brandStyle}) => {
    return (
        <ul className={`brand-list ${brandStyle}`} role="list" aria-label="Client brand logos">
            {BrandList.map((data, index) => (
                <li key={index} role="listitem">
                    <a href="#" aria-label={`Client brand logo ${index + 1}`}><img src={`${data.image}`} alt="" role="presentation" /></a>
                </li>
            ))}
        </ul>
    )
}

export default BrandThree;
